<app-app-bar></app-app-bar>

<app-main-content>
  <div class="lens-page lens-about">
    <!-- Header -->
    <section class="dash-container about-header lens-banner">
      <div>
        <h1 class="dash-section-head__title">About</h1>
        <p class="dash-section-head__subtitle">
          AAU-Hosted Ground-Truth Data Observatory and Intelligence Hub
        </p>
      </div>
    </section>

    <!-- Vision -->
    <section class="dash-container about-section">
      <header class="dash-section-head dash-section-head--compact">
        <div>
          <h2 class="dash-section-head__title">Our Vision</h2>
        </div>
      </header>

      <div class="about-card">
        <p>
          To establish a sovereign, AAU-hosted observatory and intelligence hub
          that collects and transforms ground-truth technical data into
          reliable, useful insights, empowering institutions, businesses, and
          the public to make informed decisions, plan effectively, and evaluate
          outcomes.
        </p>
      </div>
    </section>

    <!-- Version 1 Objective -->
    <section class="dash-container about-section">
      <header class="dash-section-head dash-section-head--compact">
        <div>
          <h2 class="dash-section-head__title">Version 1 Objective</h2>
          <p class="dash-section-head__subtitle">
            Building a Smarter, More Connected Campus
          </p>
        </div>
      </header>

      <div class="about-card">
        <p>
          To develop and deploy the first version of LENS at CTBE, enabling
          students and staff to measure internet quality, identify suitable
          spots for everyday activities, and access useful campus information,
          while providing university leadership with data-driven dashboards to
          monitor connectivity, identify service gaps, and support informed
          decision-making.
        </p>
      </div>
    </section>

    <!-- Contact -->
    <section class="dash-container about-section about-section--last">
      <header class="dash-section-head dash-section-head--compact">
        <div>
          <h2 class="dash-section-head__title">Contact</h2>
        </div>
      </header>

      <div class="about-contact-list">
        <div class="about-contact-item">
          <span class="about-contact-item__label">Email</span>
          <a class="about-contact-item__value" href="mailto:lens@aau.edu.et">
            lens&#64;aau.edu.et
          </a>
        </div>

        <div class="about-contact-item">
          <span class="about-contact-item__label">Phone</span>
          <a class="about-contact-item__value" href="tel:+251912641135">
            +251 91 264 1135
          </a>
        </div>
      </div>
    </section>
  </div>
</app-main-content>
